import React from 'react';

class AdviceContainer extends React.Component {

	render() {
		return (
			<div>
				<section className="hero" style={{backgroundImage: 'url(/assets/img/background4.jpg)', minHeight: 600, backgroundPosition: '50% 50%'}}>
					<div className="container">
						<div className="row">
							<div className="col-md-6 offset-md-3 text-center align-self-end">
								<h1 className="" style={{marginTop: `3em`}} >Help &amp; Advice</h1>
								<p style={{fontSize: '1.2em'}}>A list of resources to get help &amp; advice</p>
							</div>
						</div>
					</div>
				</section>


				<section className="block1">
					<div className="container" style={{paddingTop: 30, paddingBottom: 30}}>

						<h2 className="pt-5">Urgent Help Links</h2>

						<div className="row" style={{paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: Any</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Samaritans: <a href="tel:116137">116 137</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									They offer a safe place for you to talk any time you like, in your own way – about whatever’s getting to you. You don’t have to be suicidal to call us.
								</p>
								<a href="https://www.samaritans.org/how-we-can-help-you/contact-us/what-happens-when-you-contact-us" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:116137" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: Any</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">NHS Direct: <a href="tel:111">111</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									NHS 111 is staffed by team of fully trained advisers. They will ask questions to assess your symptoms and, depending on the situation, will then; 
								</p>
								<ul>
									<li>Give you self-care advice</li>
									<li>Connect you to a nurse, emergency dentist or GP</li>
									<li>Book you a face-to-face appointment</li>
									<li>Send an ambulance directly, if necessary</li>
									<li>Direct you to the local service that can help you best with your concern</li>
								</ul>
								<a href="https://www.nhs.uk/NHSEngland/AboutNHSservices/Emergencyandurgentcareservices/Pages/NHS-111.aspx" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:111" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>



						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: Any</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Emergency Services: <a href="tel:999">999</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Call 999 in a medical emergency – when someone is seriously ill or injured and their life is at risk
								</p>
								<a href="https://www.nhs.uk/NHSEngland/AboutNHSservices/Emergencyandurgentcareservices/Pages/responding-to-emergencies-FAQ.aspx" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:999" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: Under 19s</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Childline: <a href="tel:08001111">0800 1111</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Childline helps anyone under 19 in the UK with any issue they’re going through. Whether it’s something big or small, their trained counsellors are there to support you. You can call, e-mail, or chat using their online 1-2-1 chatline
								</p>
								<a href="https://www.childline.org.uk/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:08001111" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: any</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Rethink - Sheffield Helpline: <a href="tel:08088010440">0808 801 0440</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									A telephone support service for anyone affected by mental health issues. 
								</p>
								<a href="https://helplines.org/helplines/rethink-mental-illness-sheffield/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:08088010440" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: 18-65</p>
								<p>Available 24/7</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Single Point of Access (SPA) for Adult Community Mental Health Services: <a href="tel:01142263636">0114 226 3636</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									The Single Point of Access (SPA) provides a single point of contact for referring agencies and service users into adult mental health services.
								</p>
								<a href="https://www.sheffieldmentalhealth.co.uk/support/single-point-of-access-spa/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:01142263636" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: Under 35</p>
								<p>10am-10pm weekdays, 2pm-10pm weekends &amp; Bank Holidays</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Papyrus: HOPELineUK <a href="tel:08000684141">0800 068 4141</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									HOPELineUK is a confidential support and advice service for anyone under the age of 35 who might be having thoughts of suicide, or anyone concerned a young person may be having thoughts of suicide. Text: 07786209697  
								</p>
								<a href="https://www.papyrus-uk.org/help-advice/about-hopelineuk" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:08000684141" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-life-saver fa-4x pb-3"></i>
								<p>Age: any</p>
								<p>5pm-midnight 365 days a year</p>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">The Campaign Against Living Miserably (CALM) <a href="tel:0800585858">0800 58 58 58</a></h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Helpline specifically for males
								</p>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									The Campaign Against Living Miserably (CALM) is leading a movement against male suicide, the single biggest killer of men under 45 in the UK. They also offer a webchat function from 5pm – midnight every night.
								</p>
								<a href="https://www.thecalmzone.net/help/get-help/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
								<a href="tel:0800585858" className="ml-3 btn btn-outline">Call <i className="fa fa-phone" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<h2 className="pt-5">What’s available in Sheffield</h2>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Sheffield Mental Health Guide</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									A website to help the people of Sheffield easily find accurate information about mental health in our city. You can also find information about other services like Door 43, SAYiT (LGBT, SYEDA, Rainbow Heron café, Vibe (Together Women)
								</p>
								<a href="https://www.sheffieldmentalhealth.co.uk/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>
						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Amparo</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Offers support for anyone affected by suicide in South Yorkshire
								</p>
								<a href="https://amparo.org.uk/our-locations/south-yorkshire/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>
						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">The Sheffield Support Hub</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									The Sheffield Support Hub offers free mental health support in a welcoming, comfortable, non-judgmental, and non-clinical environment. Our experienced staff team is available to provide emotional, social and practical support if you are in crisis or feel you are heading toward a crisis situation. You can come just for a chat, or to access one-to-one emotional support from our experienced staff team
								</p>
								<a href="https://www.mhm.org.uk/sheffield-support-hub" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>



						<h2 className="pt-5">Looking for Help Online and National Advice Lines</h2>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Chilypep Resource Library</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Our own collection of resources and Chilypep projects for children and young people. 
								</p>
								<a href="https://chilypep.org.uk/library-resources/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Calm Harm</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Calm Harm provides tasks to help you resist or manage the urge to self-harm. You can make it private by setting a password, and personalise the app if you so wish. You will be able to track your progress and notice change.
								</p>
								<a href="https://calmharm.co.uk/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Doc Ready</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									We know that it can be difficult to talk to people when you're having difficulties with your mental health. Doc Ready helps you get ready for the first time you visit a doctor to discuss your mental health.
								</p>
								<a href="http://www.docready.org/#/home" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Epic Friends</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									This site is all about helping you to help your friends who might be struggling to cope emotionally
								</p>
								<a href="http://epicfriends.co.uk/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>



						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">HeadMeds</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									HeadMeds gives young people in the United Kingdom general information about medication. HeadMeds does not give you medical advice.
								</p>
								<a href="https://www.headmeds.org.uk/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Kooth</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Kooth, from XenZone, is an online counselling and emotional well-being platform for children and young people, accessible through mobile, tablet and desktop and free at the point of use.
								</p>
								<a href="https://kooth.com/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Mind</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Whether you’re living with a mental health problem, or supporting someone who is, Mind offers access to the right information - about a condition, treatment options, or practical issues.
								</p>
								<a href="https://www.mind.org.uk/information-support" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">NHS choices – Moodzone</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Whether you're concerned about yourself or a loved one, these helplines can offer expert advice.
								</p>
								<a href="https://www.nhs.uk/conditions/stress-anxiety-depression/mental-health-helplines/" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Papyrus</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									We exist to reduce the number of young people who take their own lives by shattering the stigma around suicide and equipping young people and their communities with the skills to recognise and respond to suicidal behaviour.
								</p>
								<a href="https://www.papyrus-uk.org/help-advice" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Rethink Advice and Information</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									Here you can find: factsheets on topics from medication to the Mental Health Act; advice and information; and an online webchat
								</p>
								<a href="https://www.rethink.org/about-us/our-mental-health-advice" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>

						<div className="row" style={{borderTop: `1px solid #92B9B2`, paddingTop: 20, paddingBottom: 20}}>
							<div className="col-md-3 text-center" style={{padding: 10}}>
								<i className="fa fa-comments fa-4x pb-3"></i>
							</div>
							<div className=" col-md-9 mt-2 mb-2">
								<h3 className="mt-2">Young Minds</h3>
								<p className="mt-3" style={{fontSize: `1.2em`}}>
									We’re leading the fight for a future where all young minds are supported and empowered, whatever the challenges. We’re here to make sure they get the best possible mental health support and have the resilience to overcome life’s difficulties.
								</p>
								<a href="https://youngminds.org.uk" target="_blank" className="btn btn-outline">Visit <i className="fa fa-mail-forward" style={{paddingLeft: 10}}></i></a>
							</div>
						</div>


					</div>
				</section>




				<div className="mt-4 container">
					<div className="row" style={{marginBottom: 0}}>
						<div className="col-md-6 text-center text-md-left">
							<img src="/assets/img/chilypep-logo.svg" className="img-fluid" style={{height: 70, marginTop: `2em`}} alt="Chilypep"/>
						</div>
						<div className="col-md-3 text-center text-md-right">						
							<img src="/assets/img/sheffieldccg-logo.png" className="img-fluid" style={{maxHeight: 100, marginTop: `2em`}} alt="Sheffield CCG"/>
						</div>
						<div className="col-md-3 text-center text-md-right">						
							<img src="/assets/img/sheffield-council.png" className="img-fluid" style={{maxHeight: 100, marginTop: `2em`, marginLeft: `2em`}} alt="Sheffield CCG"/>
						</div>
					</div>
				</div>


			</div>
		);
	}
}




export default AdviceContainer;




// WEBPACK FOOTER //
// ./src/js/components/containers/AdviceContainer.js